let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1b6MU")).then(() => parcelRequire('ke2lg'));